import { forecastReducer } from 'pages/Forecast/_store';
import { improvementsReducer } from 'pages/Improvements/_store';
import { integrationsReducer } from 'pages/Integrations/_store';
import { productivityReducer } from 'pages/Productivity/_store';
import { flexHoursReducer } from 'pages/Time/_store';
import { combineReducers } from 'redux';

import { realtimeReducer } from './realtime';
import { zoneManagementReducer } from './zoneManagement';

const pageReducers = combineReducers({
  flexHours: flexHoursReducer,
  forecast: forecastReducer,
  productivity: productivityReducer,
  zoneManagement: zoneManagementReducer,
  integrations: integrationsReducer,
  improvements: improvementsReducer,
  realtime: realtimeReducer,
});

export default pageReducers;
